import React from 'react';
import { cn } from '@/lib/utils';
import { getHtmlContentStyles } from '@/utils/html-content-styles';

interface HtmlContentProps {
  html: string;
  className?: string;
  styleOptions?: {
    h1LineHeight?: string;
    pDisplay?: string;
    headingsDisplay?: string;
  };
}

export const HtmlContent: React.FC<HtmlContentProps> = ({
  html,
  className,
  styleOptions
}) => {
  const uniqueId = React.useMemo(() => `html-content-${Math.random().toString(36).substring(2, 11)}`, []);
  const styleClassName = `html-content-${uniqueId}`;
  const combinedClassName = cn(styleClassName, className);

  return (
    <>
      <div
        className={combinedClassName}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <style>{getHtmlContentStyles(styleClassName, styleOptions)}</style>
    </>
  );
};
